function initEstimatedDelivery() {
  var container = document.getElementById("estimated");
  if (!container) return;

  function addBusinessDays(date, days) {
    var result = new Date(date);
    var added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return result;
  }

  var today = new Date();

  // ✅ Client requirement: 7–12 Business Days
  var minDate = addBusinessDays(today, 7);
  var maxDate = addBusinessDays(today, 12);

  var options = { day: "numeric", month: "short" };

  container.textContent =
    minDate.toLocaleDateString("en-GB", options) +
    " – " +
    maxDate.toLocaleDateString("en-GB", options);
}

/* Shopify-safe triggers */
document.addEventListener("DOMContentLoaded", initEstimatedDelivery);
document.addEventListener("shopify:section:load", initEstimatedDelivery);
